class ExpandableItem extends HTMLElement {
  constructor() {
    super();

    const max_height = get_max_height(this.elements.content);

    this.addEventListener("click", (event) => {
      event.preventDefault();

      if (this.classList.contains("state--active")) {
        this.classList.remove("state--active");
        this.elements.content.style.maxHeight = 0;
      } else {
        this.classList.add("state--active");
        this.elements.content.style.maxHeight = max_height + "px";
      }
    });

    function get_max_height(element) {
      element.style.maxHeight = "none";
      const h = element.clientHeight;
      element.style.maxHeight = 0;
      return h;
    }
  }

  get elements() {
    return {
      content: this.querySelector(".local--content")
    }
  }
}

customElements.define("expandable-item", ExpandableItem);
